import * as Dialog from '@radix-ui/react-dialog';
import type { ReactNode } from 'react';

interface CreateTeamModalShellProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: ReactNode;
  children: ReactNode;
}

function CreateTeamModalShell({
  open,
  onOpenChange,
  title,
  children,
}: CreateTeamModalShellProps) {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="create-team-shell-overlay" />
        <Dialog.Content className="create-team-shell-content">
          <div className="create-team-shell-header">
            <Dialog.Title className="create-team-shell-title">{title}</Dialog.Title>
          </div>
          <div className="create-team-shell-body">{children}</div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}

export default CreateTeamModalShell;
